<template>
  <Sidebar
    :set-drawer="setDrawer"
    :drawer="drawer"
    :set-is-setting="setIsSetting"
    :new-mail="newMail"
    :close-mail="closeMail"
    :item="item"
    :close-modal="closeModal"
  />
  <v-main>
    <v-container fluid>
      <v-fab
        v-if="
          $store.state.isMobile &&
          !isModal &&
          !sendModal &&
          title != 'Журнал электронной почты'
        "
        app
        icon
        location="right bottom"
        size="44px"
        color="#2CA6F7"
        @click="newMail()"
      >
        <v-icon>
          <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.5 16H3.9L13.7 6.225L12.975 5.5L12.275 4.8L2.5 14.6V16ZM1.5 18C1.21667 18 0.979003 17.904 0.787003 17.712C0.595003 17.52 0.499337 17.2827 0.500003 17V14.575C0.500003 14.3083 0.550004 14.054 0.650004 13.812C0.750004 13.57 0.89167 13.3577 1.075 13.175L13.7 0.575C13.8833 0.391667 14.1 0.25 14.35 0.15C14.6 0.0500001 14.8583 0 15.125 0C15.3917 0 15.6457 0.0500001 15.887 0.15C16.1283 0.25 16.3493 0.4 16.55 0.6L17.925 2C18.125 2.18333 18.2707 2.396 18.362 2.638C18.4533 2.88 18.4993 3.134 18.5 3.4C18.5 3.65 18.454 3.9 18.362 4.15C18.27 4.4 18.1243 4.625 17.925 4.825L5.325 17.425C5.14167 17.6083 4.929 17.75 4.687 17.85C4.445 17.95 4.191 18 3.925 18H1.5ZM13.7 6.225L12.975 5.5L12.275 4.8L13.7 6.225Z"
              fill="white"
            />
          </svg>
        </v-icon>
      </v-fab>
      <v-row v-if="!isModal && !sendModal" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-4" v-if="!$store.state.isMobile">
          <v-text-field
            v-model="search"
            variant="outlined"
            rounded="lg"
            color="#10A6F2"
            label="Поиск"
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            @click:clear="search = ''"
          >
          </v-text-field>
        </v-col>
        <v-col
          v-else
          class="d-flex justify-space-between ma-0 pa-0 align-center"
        >
          <template v-if="!isSearchMenu">
            <v-btn
              class="ma-0"
              density="compact"
              variant="text"
              color="#A1A7B0"
              @click="drawer = true"
            >
              <template v-slot:prepend>
                <icon>
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.16675 6.49458C2.16675 5.89875 2.64991 5.41666 3.24466 5.41666H11.9222C12.208 5.41666 12.4822 5.53023 12.6844 5.73238C12.8865 5.93453 13.0001 6.2087 13.0001 6.49458C13.0001 6.78046 12.8865 7.05463 12.6844 7.25678C12.4822 7.45893 12.208 7.5725 11.9222 7.5725H3.24466C2.95878 7.5725 2.68461 7.45893 2.48246 7.25678C2.28031 7.05463 2.16675 6.78046 2.16675 6.49458Z"
                      fill="#232526"
                    />
                    <path
                      d="M2.16675 13C2.16675 12.4042 2.64991 11.9221 3.24466 11.9221H22.7555C23.0414 11.9221 23.3156 12.0357 23.5177 12.2378C23.7198 12.44 23.8334 12.7142 23.8334 13C23.8334 13.2859 23.7198 13.5601 23.5177 13.7622C23.3156 13.9644 23.0414 14.078 22.7555 14.078H3.24466C2.95878 14.078 2.68461 13.9644 2.48246 13.7622C2.28031 13.5601 2.16675 13.2859 2.16675 13Z"
                      fill="#232526"
                    />
                    <path
                      d="M3.24466 18.4274C2.95878 18.4274 2.68461 18.541 2.48246 18.7431C2.28031 18.9453 2.16675 19.2194 2.16675 19.5053C2.16675 19.7912 2.28031 20.0654 2.48246 20.2675C2.68461 20.4697 2.95878 20.5832 3.24466 20.5832H16.2555C16.5414 20.5832 16.8156 20.4697 17.0177 20.2675C17.2198 20.0654 17.3334 19.7912 17.3334 19.5053C17.3334 19.2194 17.2198 18.9453 17.0177 18.7431C16.8156 18.541 16.5414 18.4274 16.2555 18.4274H3.24466Z"
                      fill="#232526"
                    />
                  </svg>
                </icon>
              </template>
            </v-btn>
            <v-btn
              class="ma-0"
              density="compact"
              icon="mdi-magnify"
              color="#A1A7B0"
              variant="text"
              @click="isSearchMenu = true"
            ></v-btn>
          </template>
          <template v-else>
            <v-text-field
              v-model="search"
              variant="outlined"
              rounded="lg"
              color="#10A6F2"
              label="Поиск"
              clearable
              hide-details
            >
              <template v-slot:append-inner>
                <v-icon v-if="model" icon="mdi-check-circle" />
              </template>
              <template v-slot:prepend-inner>
                <v-icon
                  icon="mdi-chevron-left"
                  @click.stop="isSearchMenu = false"
                ></v-icon>
              </template>
            </v-text-field>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <template v-if="title == 'Журнал электронной почты'">
          <template v-if="$store.state.isMobile">
            <v-list>
              <template v-for="item in jornalItems" :key="item.id">
                <v-list-item>
                  <v-row class="ma-0 pa-0" justify="space-between">
                    <v-col cols="10" class="ma-0 pa-0 mb-2">
                      <h4>{{ item.title }}</h4>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="1">
                      <v-btn
                        color="#616161"
                        density="compact"
                        icon="mdi-folder-open"
                        variant="text"
                        @click="item.jsonDialog = !item.jsonDialog"
                      ></v-btn>
                      <v-bottom-sheet v-model="item.jsonDialog">
                        <v-card class="pa-4 align-center rounded-t-xl">
                          <v-card-title> JSON information </v-card-title>
                          <v-card-text>
                            {{ item.json }}
                          </v-card-text>
                          <v-card-action class="justify-center">
                            <v-btn
                              color="#2CA6F7"
                              text="Скопировать"
                              variant="flat"
                              size="large"
                              rounded="xl"
                              @click="item.jsonDialog = !item.jsonDialog"
                            ></v-btn>
                          </v-card-action>
                        </v-card>
                      </v-bottom-sheet>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                      <v-list-item-subtitle>Дата</v-list-item-subtitle>
                    </v-col>
                    <v-col class="ma-0 pa-0">{{ item.date }}</v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                      <v-list-item-subtitle>От кого</v-list-item-subtitle>
                    </v-col>
                    <v-col class="ma-0 pa-0">{{ item.from_email }}</v-col>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                      <v-list-item-subtitle>Кому</v-list-item-subtitle>
                    </v-col>
                    <v-col class="ma-0 pa-0">{{ item.to_email }}</v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="mb-2"></v-divider>
              </template>
            </v-list>
          </template>
          <template v-else>
            <v-row>
              <v-col>
                <v-table
                  class="ma-2 rounded-t-lg"
                  fixed-header
                  :height="$store.state.height - 200"
                >
                  <thead>
                    <tr>
                      <th
                        v-for="header in headers"
                        :key="header.title"
                        style="background-color: #bbdefb"
                      >
                        {{ header.title }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in jornalItems"
                      :key="item.id"
                      @click="openMail(item)"
                    >
                      <td>{{ item.id }}</td>
                      <td>{{ item.title }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.from_email }}</td>
                      <td>{{ item.from_name }}</td>
                      <td>{{ item.to_email }}</td>
                      <td>
                        <v-btn
                          color="#616161"
                          density="compact"
                          icon="mdi-folder-open"
                          variant="text"
                          @click="item.jsonDialog = !item.jsonDialog"
                        ></v-btn>
                      </td>
                      <v-dialog v-model="item.jsonDialog" width="800">
                        <v-card rounded="xl" class="pa-4 align-center">
                          <v-card-title> JSON information </v-card-title>
                          <v-card-text>
                            {{ item.json }}
                          </v-card-text>
                          <v-card-action class="justify-center">
                            <v-btn
                              color="#2CA6F7"
                              text="Скопировать"
                              variant="flat"
                              size="large"
                              rounded="xl"
                              @click="item.jsonDialog = !item.jsonDialog"
                            ></v-btn>
                          </v-card-action>
                        </v-card>
                      </v-dialog>
                    </tr>
                  </tbody>
                </v-table>
              </v-col>
            </v-row>
          </template>
        </template>
        <template v-else>
          <template v-if="sendModal">
            <SendModal
              :item="item"
              v-model:modal="sendModal"
              :newMail="isNewMail"
              :fwd="fwd"
              :index="this.$store.state.index"
            />
          </template>
          <template v-else-if="isModal">
            <Modal
              :item="item"
              v-model:modal="isModal"
              v-model:favorite="item.favorite"
              v-model:sendModal="sendModal"
              v-model:newMail="isNewMail"
              v-model:fwd="fwd"
              z
              :index="this.$store.state.index"
              @deleteMail="deleteMail"
            />
          </template>
          <template v-else>
            <template v-if="this.$store.state.selectFolder.length > 0">
              <v-col>
                <v-progress-circular
                  v-if="loadingCount > 0"
                  indeterminate
                  color="primary"
                  size="50"
                  class="mx-auto my-4"
                />
                <MailsGroup
                  :search="search"
                  :setIsLoading="setLoading"
                  :folderId="this.$store.state.activeFolder"
                  :login="this.$store.state.selectNav[0].title"
                  :pass="this.$store.state.selectNav[0].pass"
                  :host="
                    this.$store.state.selectNav[0].type == 'imap'
                      ? this.$store.state.settings[
                          this.$store.state.selectNav[0].server
                        ].imap.address
                      : this.$store.state.settings[
                          this.$store.state.selectNav[0].server
                        ].host
                  "
                  :port="
                    this.$store.state.settings[
                      this.$store.state.selectNav[0].server
                    ].imap.port
                  "
                  :encrypt="this.$store.state.selectNav[0].encrypt"
                  :type="this.$store.state.selectNav[0].type"
                  :groupType="'today'"
                  :openMail="openMail"
                  :filterMails="filterMails"
                />
                <MailsGroup
                  :search="search"
                  :setIsLoading="setLoading"
                  :folderId="this.$store.state.activeFolder"
                  :login="this.$store.state.selectNav[0].title"
                  :pass="this.$store.state.selectNav[0].pass"
                  :host="
                    this.$store.state.selectNav[0].type == 'imap'
                      ? this.$store.state.settings[
                          this.$store.state.selectNav[0].server
                        ].imap.address
                      : this.$store.state.settings[
                          this.$store.state.selectNav[0].server
                        ].host
                  "
                  :port="
                    this.$store.state.settings[
                      this.$store.state.selectNav[0].server
                    ].imap.port
                  "
                  :encrypt="this.$store.state.selectNav[0].encrypt"
                  :type="this.$store.state.selectNav[0].type"
                  :groupType="'yesterday'"
                  :openMail="openMail"
                  :filterMails="filterMails"
                />
                <MailsGroup
                  :search="search"
                  :setIsLoading="setLoading"
                  :folderId="this.$store.state.activeFolder"
                  :login="this.$store.state.selectNav[0].title"
                  :pass="this.$store.state.selectNav[0].pass"
                  :host="
                    this.$store.state.selectNav[0].type == 'imap'
                      ? this.$store.state.settings[
                          this.$store.state.selectNav[0].server
                        ].imap.address
                      : this.$store.state.settings[
                          this.$store.state.selectNav[0].server
                        ].host
                  "
                  :port="
                    this.$store.state.settings[
                      this.$store.state.selectNav[0].server
                    ].imap.port
                  "
                  :encrypt="this.$store.state.selectNav[0].encrypt"
                  :type="this.$store.state.selectNav[0].type"
                  :groupType="'week'"
                  :openMail="openMail"
                  :filterMails="filterMails"
                />
              </v-col>

              <!-- <v-col
                v-for="item in selectFolder[0].items"
                :key="item.title"
                cols="12"
                class="ma-0 pa-0"
              >
                <v-card elevation="0" v-if="item.mails.length > 0">
                  <v-list :lines="$store.state.isMobile ? 'one' : 'two'">
                    <v-list-subheader
                      :title="item.title"
                      style="color: #8e8e93; font-size: 14px; line-height: 24px"
                    ></v-list-subheader>
                    <template
                      v-for="mail in filterMails(item.mails, search)"
                      :key="mail.id"
                    >
                      <v-list-item @click="openMail(mail)">
                        <v-list-item class="ma-0 pb-0">
                          <template v-slot:prepend>
                            <v-icon
                              icon="mdi-circle-medium"
                              style="position: absolute; left: -5px"
                              color="#2CA6F7"
                              v-if="mail.flag.isSeen == false"
                            />
                            <v-avatar size="34" color="primary">
                              <img
                                width="34"
                                v-if="mail.icon"
                                :src="mail.icon"
                                alt="Avatar"
                              />
                              <span v-else class="text-h6">U</span>
                            </v-avatar>
                          </template>
                          <template v-slot:append>
                            <div class="d-flex flex-column">
                              <v-list-item-subtitle
                                style="align-self: end; font-size: 12px"
                              >
                                {{
                                  item.title == "Сегодня" ||
                                  item.title == "Вчера"
                                    ? mail.timeTitle
                                    : mail.dateTitle
                                }}</v-list-item-subtitle
                              >

                              <div class="d-flex justify-end align-center">
                                <v-icon v-if="mail.attachment">
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 21 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M14.582 5.69286L6.692 13.2459C6.46775 13.4565 6.28903 13.7109 6.16687 13.9933C6.0447 14.2757 5.98167 14.5802 5.98167 14.8879C5.98167 15.1956 6.0447 15.5 6.16687 15.7824C6.28903 16.0648 6.46775 16.3192 6.692 16.5299C7.15625 16.9666 7.76962 17.2097 8.407 17.2097C9.04438 17.2097 9.65775 16.9666 10.122 16.5299L17.956 9.03186C18.3822 8.63161 18.7219 8.14827 18.9541 7.61166C19.1864 7.07506 19.3062 6.49656 19.3062 5.91186C19.3062 5.32716 19.1864 4.74867 18.9541 4.21206C18.7219 3.67545 18.3822 3.19211 17.956 2.79186C16.156 1.06886 13.238 1.06886 11.438 2.79186L3.489 10.3999C0.837 12.9399 0.837 17.0559 3.489 19.5959C6.141 22.1359 10.443 22.1349 13.096 19.5959L19.5 13.4659"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                </v-icon>
                                <v-btn
                                  style="align-self: end"
                                  :color="mail.favorite ? 'yellow' : 'black'"
                                  :icon="
                                    mail.favorite
                                      ? 'mdi-star'
                                      : 'mdi-star-outline'
                                  "
                                  variant="text"
                                  @click.stop="mail.favorite = !mail.favorite"
                                ></v-btn>
                              </div>
                            </div>
                          </template>
                          <v-list-item-title style="font-size: 16px">
                            {{ mail.fromName }}</v-list-item-title
                          >
                          <v-list-item-title style="font-size: 14px">
                            {{ mail.subject }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-col> -->
            </template>
          </template>
        </template>
      </v-row>
      <v-dialog
        v-model="isSetting"
        :fullscreen="$store.state.isMobile"
        v-touch="{
          right: () => (isSetting = false),
        }"
      >
        <v-card
          v-touch="{
            right: () => (isSetting = false),
          }"
          :rounded="$store.state.isMobile ? '' : 'xl'"
        >
          <Setting v-model="isSetting" @deleteSetting="deleteSetting" />
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import MailsGroup from "./MailsGroup.vue";
import Modal from "./Modal.vue";
import SendModal from "./SendModal.vue";

import Setting from "./Setting.vue";
import axios from "axios";
import Sidebar from "./Sidebar.vue";

export default {
  name: "Main-component",
  components: {
    Modal,
    Setting,
    SendModal,
    MailsGroup,
    Sidebar,
  },
  data() {
    return {
      // activeFolder: null,

      isNewMail: false,
      fwd: false,
      sendModal: false,
      isSearchMenu: false,
      isModal: false,
      isSetting: false,
      drawer: true,
      // selectNav: [],
      selectFolder: [],
      item: {},
      loadingCount: 0,
      search: "",
      headers: [
        {
          title: "ID",
          align: "start",
          sortable: true,
          key: "id",
        },
        {
          title: "Название",
          align: "start",
          sortable: false,
          key: "title",
        },
        {
          title: "Дата",
          align: "start",
          sortable: true,
          key: "date",
        },
        {
          title: "От кого(email)",
          align: "start",
          sortable: false,
          key: "from_email",
        },
        {
          title: "От кого(Имя)",
          align: "start",
          sortable: false,
          key: "from_name",
        },
        {
          title: "Кому",
          align: "start",
          sortable: false,
          key: "to_email",
        },
        {
          title: "Json",
          align: "start",
          sortable: false,
          key: "json",
        },
      ],
      jornalItems: [
        {
          id: 1,
          title:
            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque.",
          date: "20.12.2024",
          text: "",
          from_email: "kjg@jh.ru",
          from_name: "hjg",
          to_email: "jhhgc@jhf.ru",
          json: `{
    "name":"John",
    "age":30,
    "cars": [
        { "name":"Ford", "models":[ "Fiesta", "Focus", "Mustang" ] },
        { "name":"BMW", "models":[ "320", "X3", "X5" ] },
        { "name":"Fiat", "models":[ "500", "Panda" ] }
     ]
 }`,
          menu: false,
          jsonDialog: false,
        },
        {
          id: 2,
          title: "kgh",
          date: "22.12.2024",
          text: "",
          from_email: "kjg@jh.ru",
          from_name: "hjg",
          to_email: "jhhgc@jhf.ru",
          json: "jhg",
          menu: false,
          jsonDialog: false,
        },
        {
          id: 2,
          title: "kgh",
          date: "22.12.2024",
          from_email: "kjg@jh.ru",
          from_name: "hjg",
          to_email: "jhhgc@jhf.ru",
          json: "jhg",
          menu: false,
          jsonDialog: false,
        },
      ],
      updateInterval: null,
    };
  },

  methods: {
    setIsSetting() {
      this.isSetting = !this.isSetting;
    },
    async refreshWithMailRu() {
      try {
        console.log("refreshToken mail");
        const params = new URLSearchParams();
        params.append("type", "mailRu");
        params.append("client_id", this.$store.state.settings.Mailru.clientId);
        params.append("refresh_token", this.$store.state.selectNav[0].refresh);
        console.log({ params });
        const response = await axios.post(
          "https://spa-bitrix.ru/marketPlace_mail-app/src/refreshToken.php",
          params,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        console.log({ response });
        const mailboxSetting = this.$store.state.mailboxSetting;
        console.log({ mailboxSetting });
        const index = mailboxSetting.findIndex(
          (e) => e.title == this.$store.state.selectNav[0].title
        );
        console.log({ index });
        console.log(mailboxSetting[index]);
        mailboxSetting[index].pass = response.data.access_token;
        this.$store.state.selectNav[0].pass = response.data.access_token;
        this.$store.commit("mailboxSettingStart", mailboxSetting);
        this.$store.commit("mailboxAddStart", mailboxSetting);
      } catch (e) {
        console.log(e);
      }
    },
    async updateMails() {
      try {
        if (this.selectFolder.length > 0) {
          const formData = new FormData();
          formData.append(`params`, "getAllMailsFolderToday");
          formData.append(`login`, this.$store.state.selectNav[0].title);
          formData.append(`password`, this.$store.state.selectNav[0].pass);
          formData.append(
            `host`,
            this.$store.state.selectNav[0].type == "imap"
              ? this.$store.state.settings[
                  this.$store.state.selectNav[0].server
                ].imap.address
              : this.$store.state.settings[
                  this.$store.state.selectNav[0].server
                ].host
          );
          formData.append(`type`, this.$store.state.selectNav[0].type);
          formData.append(
            `port`,
            this.$store.state.settings[this.$store.state.selectNav[0].server]
              .imap.port
          );
          formData.append(`encrypt`, "ssl");
          formData.append(`folder_number`, this.selectFolder[0].id);

          const response = await axios.post(
            "https://email.rcgit.ru/imap/",
            formData
          );

          // Группируем новые письма по дате
          const newGroupedMessages = this.groupMessagesByDate(response.data);

          // Обновляем письма в текущей папке, добавляя только новые
          for (const key in newGroupedMessages) {
            if (this.selectFolder[0].items[key]) {
              // Если категория уже существует, добавляем только новые письма
              const existingMails = this.selectFolder[0].items[key].mails;
              const newMails = newGroupedMessages[key].mails;

              // Фильтруем новые письма, оставляя только те, которых ещё нет в existingMails
              const uniqueNewMails = newMails.filter(
                (newMail) =>
                  !existingMails.some(
                    (existingMail) => existingMail.id === newMail.id
                  )
              );

              // Добавляем уникальные новые письма в существующую категорию
              this.selectFolder[0].items[key].mails = [
                ...uniqueNewMails,
                ...existingMails,
              ];
            } else {
              // Если категории нет, добавляем её целиком
              this.selectFolder[0].items[key] = newGroupedMessages[key];
            }
          }

          console.log("Письма обновлены (дополнены)");
        }
      } catch (error) {
        console.error("Ошибка при обновлении писем:", error);
        if (this.$store.state.selectNav[0].server == "Mailru")
          this.refreshWithMailRu();
      }
    },
    filterMails(mails, searchQuery) {
      console.log(mails, searchQuery);
      if (!searchQuery) return mails; // Если поисковый запрос пуст, возвращаем все письма

      const query = searchQuery.toLowerCase(); // Приводим запрос к нижнему регистру
      console.log(searchQuery);
      return mails.filter((mail) => {
        console.log({ mail });
        // Ищем по полям subject, fromName и body

        return mail.subject && mail.from
          ? mail.subject.toLowerCase().includes(query) ||
              mail.from.toLowerCase().includes(query)
          : mail.subject
          ? mail.subject.toLowerCase().includes(query)
          : mail.from.toLowerCase().includes(query);
      });
    },
    setLoading(isLoading) {
      if (isLoading) {
        this.loadingCount++;
      } else {
        if (this.loadingCount > 0) this.loadingCount--;
      }
    },
    handleItemClick(item) {
      this.$store.commit(
        "setIndex",
        this.$store.state.mailbox.findIndex((e) => e.title == item.title)
      );

      // Если кликнули на уже выбранный элемент, ничего не делаем
      if (this.$store.state.selectNav[0] === item) {
        return;
      }
      // Иначе обновляем выбранный элемент
      this.$store.commit("setSelectNav", [item]);
      this.changeBox();
      this.isModal = false;
    },
    async changeBox() {
      try {
        this.$store.commit("setFolders", []);

        let formData = new FormData();
        formData.set(`params`, "getUserFolders");
        formData.append(`login`, this.$store.state.selectNav[0].title);
        formData.append(`password`, this.$store.state.selectNav[0].pass);
        formData.append(
          `host`,
          this.$store.state.selectNav[0].type == "imap"
            ? this.$store.state.settings[this.$store.state.selectNav[0].server]
                .imap.address
            : this.$store.state.settings[this.$store.state.selectNav[0].server]
                .host
        );
        formData.append(`type`, this.$store.state.selectNav[0].type);
        formData.append(
          `port`,
          this.$store.state.settings[this.$store.state.selectNav[0].server].imap
            .port
        );
        formData.append(`encrypt`, "ssl");
        const folders = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );
        let foldersLocal = [];
        for (const folder of folders.data) {
          foldersLocal.push({
            id: folder.id,
            title: folder.name,
            icon: folder.icon,
            items: [],
          });
        }
        await this.$store.commit("setFolders", foldersLocal);

        // formData.set(`params`, "getAllMailsFolderToday");
        // formData.set(`folder_number`, this.$store.state.selectNav[0].folders[0].id);
        // //получить все письма по каждой из папки
        // const mails = await axios.post(
        //   "https://email.rcgit.ru/imap/",
        //   formData
        // );
        // this.$store.state.selectNav[0].folders[0].items = this.groupMessagesByDate(
        //   mails.data
        // );

        this.selectFolder = [this.$store.state.folders[0]];
        this.setActive(this.$store.state.folders[0].id);
      } catch (error) {
        console.log({ error });
        if (this.$store.state.selectNav[0].server == "Mailru") {
          await this.refreshWithMailRu();
          await this.changeBox();
        }
      }
    },
    deleteSetting(mailBox) {
      this.isModal = false;
      this.$store.commit("setSelectNav", [mailBox]);
      this.changeBox();
    },
    setDrawer(data) {
      this.drawer = data;
    },
    groupMessagesByDate(messages) {
      const today = new Date(); // Текущая дата
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1); // Вчера
      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7); // Неделя назад
      const lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1); // Месяц назад

      const groupedMessages = {
        today: {
          title: "Сегодня",
          mails: [],
        },
        yesterday: {
          title: "Вчера",
          mails: [],
        },
        lastWeek: {
          title: "За последную неделю",
          mails: [],
        },
        lastMonth: {
          title: "За последний месяц",
          mails: [],
        },
        older: {
          title: "Больше месяца",
          mails: [],
        },
      };

      messages.forEach((message) => {
        console.log(message.date, "date");
        const messageDate = new Date(message.date);

        if (messageDate.toDateString() === today.toDateString()) {
          groupedMessages.today.mails.push(message); // Сегодня
        } else if (messageDate.toDateString() === yesterday.toDateString()) {
          groupedMessages.yesterday.mails.push(message); // Вчера
        } else if (messageDate > lastWeek) {
          groupedMessages.lastWeek.mails.push(message); // За последнюю неделю
        } else if (messageDate > lastMonth) {
          groupedMessages.lastMonth.mails.push(message); // За последний месяц
        } else {
          groupedMessages.older.mails.push(message); // Старое
        }
      });

      return groupedMessages;
    },
    async getSelectFolder() {
      try {
        let formData = new FormData();
        formData.append(`login`, this.$store.state.selectNav[0].title);
        formData.append(`password`, this.$store.state.selectNav[0].pass);
        formData.append(
          `host`,
          this.$store.state.selectNav[0].type == "imap"
            ? this.$store.state.settings[this.$store.state.selectNav[0].server]
                .imap.address
            : this.$store.state.settings[this.$store.state.selectNav[0].server]
                .host
        );
        formData.append(`type`, this.$store.state.selectNav[0].type);
        formData.append(
          `port`,
          this.$store.state.settings[this.$store.state.selectNav[0].server].imap
            .port
        );
        console.log(
          this.$store.state.settings[this.$store.state.selectNav[0].server].imap
            .port
        );
        formData.append(`encrypt`, "ssl");
        formData.append(`params`, "getAllMailsFolder");
        formData.append(`folder_number`, this.selectFolder[0].id);
        //получить все письма по каждой из папки
        const mails = await axios.post(
          "https://email.rcgit.ru/imap/",
          formData
        );

        this.selectFolder[0].items = this.groupMessagesByDate(mails.data);
      } catch (error) {
        console.log({ error });
      }
    },
    newMail() {
      this.isNewMail = true;
      this.fwd = false;
      this.item = {};
      this.sendModal = !this.sendModal;
      this.isModal = false;
    },
    closeModal() {
      this.isModal = false;
    },
    deleteMail(item) {
      try {
        console.log({ item });
        for (const key in this.selectFolder[0].items) {
          const category = this.selectFolder[0].items[key];

          // Фильтруем массив cards, удаляя элемент с id === 3
          category.mails = category.mails.filter((mail) => mail.id !== item.id);
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async openMail(item) {
      let formData = new FormData();
      formData.append(`params`, "getBodyMail");
      formData.append(`login`, this.$store.state.selectNav[0].title);
      formData.append(`password`, this.$store.state.selectNav[0].pass);
      formData.append(
        `host`,
        this.$store.state.selectNav[0].type == "imap"
          ? this.$store.state.settings[this.$store.state.selectNav[0].server]
              .imap.address
          : this.$store.state.settings[this.$store.state.selectNav[0].server]
              .host
      );
      formData.append(`type`, this.$store.state.selectNav[0].type);
      formData.append(
        `port`,
        this.$store.state.settings[this.$store.state.selectNav[0].server].imap
          .port
      );
      formData.append(`encrypt`, "ssl");
      formData.append(`folder_number`, this.$store.state.selectFolder[0].id);
      formData.append(`id`, item.id);

      //получить все письма по каждой из папки
      const mail = await axios.post("https://email.rcgit.ru/imap/", formData);
      this.isModal = true;
      item.body = mail.data.body;
      item.files = mail.data.files;
      item.folderId = this.$store.state.selectFolder[0].id;
      item.flag.isSeen = true;
      this.item = item;
    },
    closeMail() {
      this.isModal = false;
      let item = {};
      this.item = item;
    },
    isActive(folderId) {
      return this.$store.state.activeFolder == folderId; // Проверка, активен ли элемент
    },
    setActive(folderId) {
      this.$store.commit("setActiveFolder", folderId);
    },
    async loadFolderByQuery() {
      const folderId = this.$route.query.folder;
      if (folderId) {
        const folder = this.findFolderById(folderId);
        if (folder) {
          this.setActive(folder.id);
          this.selectFolder = [folder];
        }
      } else {
        this.$router.push(`/?folder=${this.$store.state.activeFolder}`);
      }
    },

    findFolderById(folderId) {
      for (const folder of this.$store.state.folders) {
        if (folder.id == folderId) return folder;
      }
      return null;
    },
  },

  // watch: {
  //   "$route.query.folder": function () {
  //     this.loadFolderByQuery();
  //   },
  // },
  async mounted() {
    if (this.$store.state.isMobile) this.drawer = false;
    // this.$store.commit("setSelectNav", [
    //   ...this.$store.state.selectNav,
    //   this.$store.state.mailbox[0],
    // ]);
    // this.$store.commit("setIndex", 0);

    // await this.changeBox();

    // this.loadFolderByQuery();
    // this.selectFolder.push(this.$store.state.selectNav[0].folders[0]);
    // Запускаем обновление писем каждые 10 секунд
    // this.updateInterval = setInterval(() => {
    //   this.updateMails();
    // // }, 10000); // 10000 мс = 10 секунд
  },
  beforeUnmount() {
    // Очищаем интервал при уничтожении компонента
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
};
</script>
<style>
.v-list-item__prepend > .v-badge ~ .v-list-item__spacer,
.v-list-item__prepend > .v-icon ~ .v-list-item__spacer,
.v-list-item__prepend > .v-tooltip ~ .v-list-item__spacer {
  width: 12px;
}

.active-icon svg path {
  fill: rgb(16, 166, 242) !important;
}

.v-icon svg path div {
  stroke: #a6acb5;
  fill: #a6acb5;
}

.active-item {
  border-radius: 16px;
  color: rgb(16, 166, 242);
  background-color: rgba(16, 166, 242, 0.12);
}
</style>
